import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { HcTableDataSource } from '@healthcatalyst/cashmere';

@Component({
    selector: 'cdp-grid-states',
    templateUrl: './grid-states.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class GridStatesComponent {
    /** Singular name of the type of element in this table */
    @Input() nameSingular = '';
    /** Plural name of the type of element in this table */
    @Input() namePlural = 'items';
    /** If true, show loading spinner */
    @Input() loading = false;
    /** Set to true for a "load failed" message and a "refresh" link */
    @Input() loadFailed = false;
    /** Filter term being applied */
    @Input() searchValue = '';
    /** Set this to true to get a button for adding a new item when an empty state is shown. */
    @Input() allowAddNew = true;
    /** The text to show in the add button. Defaults to 'New {{this.nameSingular}}' */
    @Input() addButtonText = '';
    /** Style of the add button. Uses cashmere button styles. Defaults to primary. */
    @Input() addButtonStyle = 'primary';
    /** The text to show when there are no items in grid. Defaults to 'No {{this.namePlural}} to show' */
    @Input() emptyMsg = '';
    /** The icon to show in the add button */
    @Input() addButtonIcon = 'icon-add';
    /** Set this to true if all columns on this table are hidden and you want the "no columns selected" message displayed. */
    @Input() noColsSelected = false;
    /** Set this to true if columns on this table can be hidden/shown and you'll want the "no columns selected" message displayed as needed. */
    @Input() hasEditableCols = true;
    /** Reference to the datasource being used on the associated table */
    @Input() dataSource = new HcTableDataSource<any>();
    /** Override dataSource.data.length. Useful if you cannot use the standard HcTableDataSource */
    @Input() dataCount: number | undefined;
    /** Override dataSource.filteredData.length. Useful if you cannot use the standard HcTableDataSource */
    @Input() filterMatchDataCount: number | undefined;
    @Output() clearSearch = new EventEmitter<void>();
    @Output() refresh = new EventEmitter<void>();
    @Output() createNew = new EventEmitter<void>();
    @Output() selectCols = new EventEmitter<void>();

    get hasData(): boolean {
        return this.dataCount !== undefined ? this.dataCount > 0 : this.dataSource.data.length > 0;
    }

    get hasFilterMatchData(): boolean {
        return this.filterMatchDataCount !== undefined
            ? this.filterMatchDataCount > 0
            : this.dataSource.filteredData.length > 0;
    }
}
